import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'wl-currency-symbol',
  templateUrl: 'currency-symbol.component.html',
    standalone: false
})
export class CurrencySymbolComponent implements OnInit {
  public currencySymbol: string;
  public constructor() {
    this.currencySymbol = '$';
  }

  ngOnInit() {}
}
